module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S8 Coral Blue.051f0f91.png";